<div class="switch" [class.checked]="model" (click)="toggleSwitch()">
  <div class="slider"></div>
</div>